export const getPropertyNamePrefix = ({
  namePrefix,
  properties,
  propertyKey,
}: {
  namePrefix: any;
  properties: any;
  propertyKey: any;
}) => {
  const propertyIndex = properties.findIndex(
    (property: any) => property.key === propertyKey,
  );

  return `${namePrefix}.properties[${propertyIndex}]`;
};
